import { useEffect, useRef, useState } from 'react';
import { $downloadRecipientStore } from '@lib/store';
import { Button, Icon, MessageFile, Modal } from '@shared/widgets';
import PaperclipIcon from '@assets/icons/paperclip.svg';

interface Props {
  show: boolean;
  onClose: () => void;
  onSave: (file?: File, isDeleted?: boolean) => void;
  refNum: string;
  receipt?: string | null;
  removeReceipt: () => void;
}

export const AddReceiptModal = (props: Props) => {
  const [file, setFile] = useState<File>();
  const [initialFile, setInitialFile] = useState<string | undefined>();
  const [isDeleted, setIsDeleted] = useState<boolean>(false);
  const uploadRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (props.receipt) {
      setInitialFile(props.receipt);
    } else {
      setInitialFile(undefined);
    }
    setFile(undefined);
    setIsDeleted(false);
  }, [props.show]);

  const download = () => $downloadRecipientStore.events.downloadRecipient(props.refNum);
  const upload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    const uploadedFile = e.target.files[0];
    setFile(uploadedFile);
  };

  return (
    <Modal isOpen={props.show} title='Receipt' onClose={props.onClose}>
      <div className='mb-5'>
        {initialFile || file ? (
          <MessageFile
            downloadShow={!file ? false : true}
            download={download}
            attachment={{
              id: '',
              filename: initialFile ? initialFile : file?.name,
              fileSizeBytes: initialFile ? undefined : file?.size,
            }}
            onRemove={() => {
              if (file) {
                setFile(undefined);
              }
              if (initialFile) {
                setInitialFile(undefined);
                props.removeReceipt();
                setIsDeleted(true);
              }
            }}
          />
        ) : (
          <div className='mb-6'>
            <input ref={uploadRef} id='contained-button-file' className='hidden' type='file' accept='image/*' onChange={upload} />
            <label htmlFor='contained-button-file'>
              <Button color='dashed' fullWidth onClick={() => uploadRef.current?.click()}>
                <Icon icon={<PaperclipIcon />} color='inherit' />
                Add attachment
              </Button>
            </label>
          </div>
        )}
      </div>
      <Button color='primary' fullWidth onClick={() => props.onSave(file, isDeleted)}>
        Save
      </Button>
    </Modal>
  );
};
